import React from 'react';

export default props => {
    return (    
        <svg width="34px" className={props.className} onClick={() => props.onClick ? props.onClick() : null} height="20px" viewBox="0 0 34 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="xxl_down_arrow_blue" transform="translate(0.000000, -14.000000)" fill={props.color || '#002857'}>
                    <g id="Group" transform="translate(0.000000, 14.000000)">
                        <rect id="Rectangle-22" transform="translate(9.899495, 10.041631) rotate(-45.000000) translate(-9.899495, -10.041631) " x="7.89949494" y="-1.95836944" width="4" height="24"></rect>
                        <rect id="Rectangle-22-Copy" transform="translate(24.041631, 10.041631) rotate(-315.000000) translate(-24.041631, -10.041631) " x="22.0416306" y="-1.95836944" width="4" height="24"></rect>
                    </g>
                </g>
            </g>
        </svg>
    );
}



// WEBPACK FOOTER //
// ./src/images/PointerDown.js